// Back to Top Button with rAF-throttled scroll
$(document).ready(function () {
	var backToTop = $(".back-top");
	var ticking = false;

	$(window).on("scroll", function () {
		if (!ticking) {
			window.requestAnimationFrame(function () {
				if ($(window).scrollTop() > 300) {
					backToTop.addClass("show");
				} else {
					backToTop.removeClass("show");
				}
				ticking = false;
			});
			ticking = true;
		}
	});

	backToTop.click(function () {
		$("html, body").animate({ scrollTop: 0 }, 800);
		return false;
	});
});
